var DataCardModule = /** @class */ (function () {
    function DataCardModule() {
    }
    return DataCardModule;
}());
export { DataCardModule };
